<template>
  <div>
    <div class="row full-width-header" v-if="accountabilityId">
      <div class="col">
        <v-header :title="title" :isNewAccountability="isNewAccountability" :accountabilityId="accountabilityId"></v-header>
        <div class="row grid-padding">
          <div class="col-xs-12 col-md-10 col-lg-6">
            <div class="row">
              <div class="col-xs-12 col-md-8">
                <v-heading :level="3">Verantwoorden</v-heading>
              </div>
              <div class="col-xs-12 col-md-4 grid-justify-content-center grid-align-end">
                <router-link class="link" :to="'/machtiging/'+accountabilityId">wijzigen</router-link>
              </div>
            </div>
            <table id="step1" class="accountability-overview">
              <tr v-for="(question, indexquestion) in questions" :key="indexquestion" :data-index="indexquestion" >
                <td v-if="!question.IsLaatste">{{question.Tekst}}</td>
                <template v-for="(answer, index) in question.Antwoorden" >
                  <td v-bind:key="index" v-if="answer.TypeCode === 'Standard' && question.ResultaatAnswers[0].AnswerId === answer.AnswerId">
                    {{answer.AntwoordTekst}}
                  </td>
                  <td v-bind:key="index" v-if="( answer.TypeCode === 'OpenStandaard' || answer.TypeCode === 'Open' ) && question.ResultaatAnswers[0].AnswerId === answer.AnswerId">
                    {{answer.AntwoordTekst}}
                    <div class="openquestion" v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId">
                      <div v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerId === answer.AnswerId">
                        {{question.ResultaatAnswers[0].Resultaat}}
                      </div>
                    </div>
                  </td>
                  <td v-bind:key="index" v-if="answer.TypeCode === 'Dropdown'">
                    <div v-for="(option, indexoptions) in answer.AntwoordLijst" :key="indexoptions" :data-index="indexoptions"  >
                      <div v-if="question.ResultaatAnswers.length > 0 && question.ResultaatAnswers[0].AnswerListItemId === option.AnswerListItemId ">{{option.Omschrijving}}</div>
                    </div>
                  </td>
                </template>
              </tr>
            </table>
            <div class="row" v-if="!isSingleAccountability">
              <div class="col-xs-12 col-md-8">
                <v-heading :level="3">Producten</v-heading>
              </div>
              <div class="col-xs-12 col-md-4 grid-justify-content-center grid-align-end">
                <router-link class="link" :to="'/machtiging/'+accountabilityId">Meer producten toevoegen</router-link>
              </div>
            </div>
            <div tagelement="section" class="products-selected" v-if="!isSingleAccountability">
              <strong class="products-selected__daily-dosage">Geselecteerd voor totaal dagdosering</strong>
              <v-empty-message v-if="productsSelectedDailyDosage.length < 1">
                Geen producten geselecteerd met totaal dagdosering
              </v-empty-message>
              <ul class="products-selected__list daily_dosage">
                <v-product v-for="(product, index) in productsSelectedDailyDosage" :data="product" :key="product.ProductId" selected :alt="product.Smaakbox">
                  <div v-if="productsSelectedDailyDosage.length === index + 1" slot="actions" class="product__text__dosage">Totaal dosering: {{ product.Basket_UnitOfMeasure }}</div>
                </v-product>
              </ul>
              <div class="products-seperator"></div>
              <v-empty-message v-if="productsSelectedNoDailyDosage.length < 1">
                Geen producten geselecteerd zonder totaal dagdosering
              </v-empty-message>
              <ul class="products-selected__list">
                <v-product v-for="product in productsSelectedNoDailyDosage" :data="product" :key="product.ProductId" selected :alt="product.Smaakbox">
                  <div slot="actions" class="product__text__dosage">{{ product.Basket_UnitOfMeasure }}</div>
                </v-product>
              </ul>
            </div>
            <form name="accountabilityOverview" @submit.prevent="validateBeforeSubmit" v-if="formConfig">
              <template v-if="VTPlusVisibilityStatus">
                <div class="information-container">
                  <v-heading :level="3">{{patientGegevens.CareProgramInfo.VTPlus.Header}}</v-heading>
                  <div class="vtplusvoorwaarden">
                    <div class="rte" v-html="patientGegevens.CareProgramInfo.VTPlus.Text"></div>
                  </div>
                  <v-checkbox-group
                    v-model="formConfig.IsVTPlus.model"
                    :error="!!formErrors[formConfig.IsVTPlus.ref]"
                    :errorMessage="formErrors[formConfig.IsVTPlus.ref]"
                    :rule="formConfig.IsVTPlus.rule"
                    :label="patientGegevens.CareProgramInfo.VTPlus.Footer"
                    :inputid="formConfig.IsVTPlus.ref"
                    :initvalue="formConfig.IsVTPlus.model"
                  >
                  </v-checkbox-group>
                </div>
              </template>
              <v-heading :level="3">Bezorging</v-heading>
              <div class="form-group__radio" v-if="patientGegevens.WoonAdres" >
                <input id="woonadres" name="deliveryaddress" type="radio" checked @change="checkRadioAddress"/>
                <label for="woonadres"><span><span></span></span>
                  {{patientGegevens.WoonAdres.Straatnaam}}
                  {{patientGegevens.WoonAdres.Huisnummer}}
                  {{patientGegevens.WoonAdres.Toevoeging}},
                  {{patientGegevens.WoonAdres.Postcode}},
                  {{patientGegevens.WoonAdres.Woonplaats}} ({{patientGegevens.WoonAdres.Land}})
                </label>
              </div>
              <div class="form-group__radio" v-if="patientGegevens.AfwijkendeAdres">
                <input id="afwijkendwoonadres" name="deliveryaddress" type="radio" @change="checkRadioAddress"/>
                <label for="afwijkendwoonadres"><span><span></span></span>
                  {{patientGegevens.AfwijkendeAdres.Straatnaam}}
                  {{patientGegevens.AfwijkendeAdres.Huisnummer}}
                  {{patientGegevens.AfwijkendeAdres.Toevoeging}},
                  {{patientGegevens.AfwijkendeAdres.Postcode}},
                  {{patientGegevens.AfwijkendeAdres.Woonplaats}} ({{patientGegevens.AfwijkendeAdres.Land}})
                </label>
              </div>
              <div class="form-group__radio">
                <input id="differentaddress" name="deliveryaddress" type="radio" @change="checkRadioAddress" />
                <label for="differentaddress"><span><span></span></span> Ander bezorgadres
                </label>
              </div>
              <transition name="fade">
                <div v-if="differentAddress" class="extrafields">
                  <div class="row grid-margin">
                    <div class="col-xs-4">
                      <v-input-group
                        maxlength="7"
                        v-model="formData[formConfig.newAddressPostcode.ref]"
                        @blur="validateField(formConfig.newAddressPostcode.ref, formData[formConfig.newAddressPostcode.ref]); autoFillAddress();"
                        :error="!!formErrors[formConfig.newAddressPostcode.ref]"
                        :errorMessage="formErrors[formConfig.newAddressPostcode.ref]"
                        initvalue=""
                        :rule="formConfig.newAddressPostcode.rule"
                        :label="formConfig.newAddressPostcode.label"
                        :inputid="formConfig.newAddressPostcode.ref">
                      </v-input-group>
                    </div>
                    <div class="col-xs-4">
                      <v-input-group
                        v-model="formData[formConfig.newAddressHuisnummer.ref]"
                        @blur="validateField(formConfig.newAddressHuisnummer.ref, formData[formConfig.newAddressHuisnummer.ref]); autoFillAddress();"
                        :error="!!formErrors[formConfig.newAddressHuisnummer.ref]"
                        :errorMessage="formErrors[formConfig.newAddressHuisnummer.ref]"
                        initvalue=""
                        :rule="formConfig.newAddressHuisnummer.rule"
                        :label="formConfig.newAddressHuisnummer.label"
                        :inputid="formConfig.newAddressHuisnummer.ref">
                      </v-input-group>
                    </div>
                    <div class="col-xs-4">
                      <v-input-group
                        v-model="formData[formConfig.newAddressToevoeging.ref]"
                        @blur="validateField(formConfig.newAddressToevoeging.ref, formData[formConfig.newAddressToevoeging.ref])"
                        :error="!!formErrors[formConfig.newAddressToevoeging.ref]"
                        :errorMessage="formErrors[formConfig.newAddressToevoeging.ref]"
                        initvalue=""
                        :rule="formConfig.newAddressToevoeging.rule"
                        :label="formConfig.newAddressToevoeging.label"
                        :inputid="formConfig.newAddressToevoeging.ref">
                      </v-input-group>
                    </div>
                  </div>
                  <div class="row grid-margin">
                    <div class="col">
                      <v-input-group
                        v-model="formData[formConfig.newAddressStraatnaam.ref]"
                        @blur="validateField(formConfig.newAddressStraatnaam.ref, formData[formConfig.newAddressStraatnaam.ref])"
                        :error="!!formErrors[formConfig.newAddressStraatnaam.ref]"
                        :errorMessage="formErrors[formConfig.newAddressStraatnaam.ref]"
                        initvalue=""
                        :rule="formConfig.newAddressStraatnaam.rule"
                        :label="formConfig.newAddressStraatnaam.label"
                        :inputid="formConfig.newAddressStraatnaam.ref"
                        :disabled="formConfig.newAddressStraatnaam.disabled"
                        :overwriteValue="oStreet">
                      </v-input-group>
                    </div>
                    <div class="col">
                      <v-input-group
                        v-model="formData[formConfig.newAddressWoonplaats.ref]"
                        @blur="validateField(formConfig.newAddressWoonplaats.ref, formData[formConfig.newAddressWoonplaats.ref])"
                        :error="!!formErrors[formConfig.newAddressWoonplaats.ref]"
                        :errorMessage="formErrors[formConfig.newAddressWoonplaats.ref]"
                        initvalue=""
                        :rule="formConfig.newAddressWoonplaats.rule"
                        :label="formConfig.newAddressWoonplaats.label"
                        :inputid="formConfig.newAddressWoonplaats.ref"
                        :disabled="formConfig.newAddressWoonplaats.disabled"
                        :overwriteValue="oCity">
                      </v-input-group>
                    </div>
                    <div class="col" v-if="stamDataLanden.Landen">
                      <v-select-group
                        v-model="formData[formConfig.newAddressLand.ref]"
                        :label="formConfig.newAddressLand.label"
                        :selectid="formConfig.newAddressLand.ref"
                        :initselected="'NL'">
                        <option v-for="(item, index) in this.stamDataLanden.Landen"
                                :key="index"
                                :data-index="index" :value="item.IsoCode">{{ item.Naam }}</option>
                      </v-select-group>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="form-group__radio" v-if="hasAccessories">
                <input
                  id="hospital"
                  name="deliveryaddress"
                  type="radio"
                  @change="checkRadioAddress" />
                <label for="hospital"><span><span></span></span> {{formConfig.hospitalDelivery.label}}
                </label>
              </div>
              <transition name="fade">
                <div v-if="hospitalAddress" class="extrafields">
                  <legend>Afspreken met:</legend>
                  <div class="row grid-margin">
                    <div class="col">

                      <v-input-group
                        v-model="formData[formConfig.hospitalNameDepartment.ref]"
                        @blur="validateField(formConfig.hospitalNameDepartment.ref, formData[formConfig.hospitalNameDepartment.ref])"
                        :error="!!formErrors[formConfig.hospitalNameDepartment.ref]"
                        :errorMessage="formErrors[formConfig.hospitalNameDepartment.ref]"
                        initvalue=""
                        :rule="formConfig.hospitalNameDepartment.rule"
                        :label="formConfig.hospitalNameDepartment.label"
                        :inputid="formConfig.hospitalNameDepartment.ref">
                      </v-input-group>
                    </div>
                    <div class="col">
                      <v-input-group
                        v-model="formData[formConfig.hospitalTelephone.ref]"
                        @blur="validateField(formConfig.hospitalTelephone.ref, formData[formConfig.hospitalTelephone.ref])"
                        :error="!!formErrors[formConfig.hospitalTelephone.ref]"
                        :errorMessage="formErrors[formConfig.hospitalTelephone.ref]"
                        initvalue=""
                        :rule="formConfig.hospitalTelephone.rule"
                        :label="formConfig.hospitalTelephone.label"
                        :inputid="formConfig.hospitalTelephone.ref">
                      </v-input-group>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="information-container"  v-if="hasAccessories">
                <v-heading :level="3">Aanvullende informatie gewenst</v-heading>
                <v-paragraph>Voor de patient zijn toebehoren geselecteerd. Om u en de patient beter van dienst te kunnen zijn verzoeken wij u de volgende gegevens in te vullen.</v-paragraph>
                <legend>Gewenst aflevermoment (datum en dagdeel) </legend>
                <div class="row grid-margin">
                  <div class="col">
                    <v-input-date-picker
                      ref="date"
                      type="date"
                      name="deliveryDay"
                      id="deliveryDay"
                      autofocus
                      emptyDate
                      :disableNextDate="computedNextDayStatus"
                      :dateBetweenRange="dateBetweenRange"
                      :holidayDates="holidayDates"
                      @updateValidation="updateValidation"
                    >
                    </v-input-date-picker>
                  </div>
                  <div class="col">
                    <v-select-group
                      v-model="formData[formConfig.deliveryTime.ref]"
                      @blur="validateField(formConfig.deliveryTime.ref, formData[formConfig.deliveryTime.ref])"
                      :label="formConfig.deliveryTime.label"
                      selectid="deliveryTime"
                      :error="!!formErrors[formConfig.deliveryTime.ref]"
                      :errorMessage="formErrors[formConfig.deliveryTime.ref]"
                      initselected="">
                      <option value="no_preference">Geen voorkeur</option>
                      <option value="morning">Ochtend</option>
                      <option value="afternoon">Middag</option>
                    </v-select-group>
                  </div>
                </div>
                <div class="row grid-margin" v-if="computedNextDayStatus">
                  <div class="col">
                    <v-warning-message :class="{'zoomOut animated': animated}" :warning="'Bestellingen na 17:00 uur kunnen niet meer de volgende werkdag geleverd worden. Kies een andere dag.'" :html="false" :isUrgent='false'></v-warning-message>
                  </div>
                </div>
                <div class="row grid-margin">
                  <div class="col">
                    <v-checkbox-group
                      v-model="formData[formConfig.instruction.ref]"
                      :label="formConfig.instruction.label"
                      :inputid="formConfig.instruction.ref"
                      @input="updateInstructionType( ...arguments)"
                      >
                    </v-checkbox-group>
                  </div>
                </div>
                <div class="row grid-margin" v-if="showInstructionOptions">
                  <div class="col instruction-type">
                  {{deliveryInstructionLabels.SubHeader}}
                  <div class="form-group__radio">
                    <input id="deliveryinstruction-house" name="deliveryInstruction" type="radio" @change="deliveryInstructionErrorMsg =1" value="2" v-model="formData[formConfig.instructionType.ref]"/>
                    <label for="deliveryinstruction-house"><span><span></span></span> {{deliveryInstructionLabels.HomeVisit}}</label>
                  </div>
                  <div class="form-group__radio">
                    <input id="deliveryinstruction-videocall" name="deliveryInstruction" type="radio" @change="deliveryInstructionErrorMsg =2" value="1" v-model="formData[formConfig.instructionType.ref]"/>
                    <label for="deliveryinstruction-videocall"><span><span></span></span> {{deliveryInstructionLabels.VideoCall}}</label>
                  </div>
                  <div class="form-group__radio">
                    <input id="deliveryinstruction-hospital" name="deliveryInstruction" type="radio" @change="deliveryInstructionErrorMsg =3" value="3" v-model="formData[formConfig.instructionType.ref]"/>
                    <label for="deliveryinstruction-hospital"><span><span></span></span> {{deliveryInstructionLabels.HospitalVisit}}</label>
                  </div>
                  <div class="form-group-simple__details" v-show="formSubmitted && showInstructionOptions && deliveryInstructionErrorMsg===0">
                    <div class="form-group-simple__messages">
                      <div class="form-group-simple__error">Kies één van de opties hierboven om verder te gaan.</div>
                    </div>
                  </div>
                  </div>
                </div>
                <div class="row grid-margin">                    
                  <div class="col form-group__radio delivery_rdb_question">
                    <v-checkbox-group
                      v-model="isCheckThuiszorg"
                      :initvalue="isCheckThuiszorg"
                      :label="formConfig.homecare.label"
                      :inputid="'chkThuiszorg'"
                      @input="showThuiszorgQuestion( ...arguments)">
                    </v-checkbox-group>
                  </div>
                </div>
                <div v-if="thuiszorgQuestion">
                  <div class="row">
                    <div class="col form-group__radio delivery_rdb_answer">
                      <input id="ja" v-model="formData[formConfig.homecare.ref]" name="Homecare" value="1" type="radio" @change="checkThuiszorg" />
                      <label for="ja"><span><span></span></span> Ja
                      </label>
                    </div>
                  </div>
                  <transition name="fade">
                    <div class="row grid-margin delivery_txt_answer" v-if="thuiszorgFields">
                      <div class="col">
                        <v-input-group
                          v-model="formData[formConfig.nameThuiszorg.ref]"
                          @blur="validateField(formConfig.nameThuiszorg.ref, formData[formConfig.nameThuiszorg.ref])"
                          :error="!!formErrors[formConfig.nameThuiszorg.ref]"
                          :errorMessage="formErrors[formConfig.nameThuiszorg.ref]"
                          :initvalue="formData[formConfig.nameThuiszorg.ref]"
                          :rule="formConfig.nameThuiszorg.rule"
                          :label="formConfig.nameThuiszorg.label"
                          :inputid="formConfig.nameThuiszorg.ref">
                        </v-input-group>
                      </div>
                      <div class="col">
                        <v-input-group
                          v-model="formData[formConfig.telephoneThuiszorg.ref]"
                          @blur="validateField(formConfig.telephoneThuiszorg.ref, formData[formConfig.telephoneThuiszorg.ref])"
                          :error="!!formErrors[formConfig.telephoneThuiszorg.ref]"
                          :errorMessage="formErrors[formConfig.telephoneThuiszorg.ref]"
                          :initvalue="formData[formConfig.telephoneThuiszorg.ref]"
                          :rule="formConfig.telephoneThuiszorg.rule"
                          :label="formConfig.telephoneThuiszorg.label"
                          :inputid="formConfig.telephoneThuiszorg.ref">
                        </v-input-group>
                      </div>
                    </div>
                  </transition>
                  <div class="row">
                    <div class="col form-group__radio delivery_rdb_answer">
                      <input id="nee" v-model="formData[formConfig.homecare.ref]" name="Homecare" value="2" type="radio" @change="checkThuiszorg" />
                      <label for="nee"><span><span></span></span> Nee
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col form-group__radio delivery_rdb_answer">
                      <input id="nietbekend" v-model="formData[formConfig.homecare.ref]" name="Homecare" value="3" type="radio" @change="checkThuiszorg" />
                      <label for="nietbekend"><span><span></span></span> Niet bekend
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div id="step2">
                <v-heading :level="3">Voorgeschreven voeding direct leveren?</v-heading>
                <div class="form-group__radio" >
                  <input id="isdirectdelivery-yes" name="isdirectdelivery" type="radio" value="true" @change="showDirectDeliveryMsg =true" checked v-model="formData[formConfig.isdirectdelivery.ref]"/>
                  <label for="isdirectdelivery-yes"><span><span></span></span> Ja</label>
                </div>
                <div class="form-group__radio">
                  <input id="isdirectdelivery-no" name="isdirectdelivery" type="radio" value="false" @change="showDirectDeliveryMsg =false" v-model="formData[formConfig.isdirectdelivery.ref]"/>
                  <label for="isdirectdelivery-no"><span><span></span></span> Nee</label>
                </div>
              </div>
              <v-warning-message v-if="!showDirectDeliveryMsg" :message="texts.directDeliveryText" :html="true"></v-warning-message>
              <div class="information-container" v-if="showDirectDeliveryMsg">
                <v-heading :level="3">{{ texts.repeatOrderTitle }}</v-heading>
                <v-paragraph>{{ texts.repeatOrderDescription }}</v-paragraph>
                <div class="row grid-margin">
                  <div class="col">
                    <v-checkbox-group
                    :label="texts.repeatOrderCheckboxText"
                    inputid="repeatOrder"
                    v-model="repeatOrder"
                    :overwriteValue="repeatOrder"
                    ></v-checkbox-group>
                  </div>
                </div>
              </div>
              <v-heading :level="3">Opmerkingen</v-heading>
              <v-textarea-group
                v-model="formData[formConfig.comment.ref]"
                :rule="formConfig.comment.ref"
                :label="formConfig.comment.label"
                :inputid="formConfig.comment.ref"
              ></v-textarea-group>
              <div class="row" v-if="showExtendLicensesBlock">
                <v-heading :level="3" class="extHeader">{{ExtendLicenseMsg.Header}}</v-heading>
                <div class="rte"> <v-paragraph>{{ExtendLicenseMsg.Text}}</v-paragraph></div>
                <!--DROPDOWN QUESTION -->
                <v-select-group
                label="Maak een keuze"
                v-model="extendLicensesMonth"
                :selectid="extendLicensesMonth"
                :initselected="extendLicensesMonth"
                :rule="formConfig.extendLicense.ref"
                @change="checkSelectAnswer"
                >
                <option v-for="(monthOption, monIndex) in extendLicenseOptions" :key="monIndex" :initvalue="extendLicensesMonth" :value="monthOption.value" :selected="monIndex === 0">{{monthOption.label}}</option>
                </v-select-group>
                <span class="extendLicenseFromEndDate">
                  <v-checkbox-group
                  v-model="extendLicenseFromEndDate"
                  label="Aansluitend verlengen na de einddatum van de huidige machtiging."
                  inputid="extendLicenseFromEndDate"
                  :overwriteValue="extendLicenseFromEndDate"
                  ></v-checkbox-group>
                </span>
              </div>
              <table class="table prescriber__signature" v-if="canSign && hasMultipleSignees">
                <tbody>
                  <tr v-if="hasMultipleSignees">
                    <td colspan="2">
                      <v-select-group
                      label="Beschikbare volmachtgevers"
                      selectid="warranter"
                      initselected=""
                      @change="setSelectedSigneePpwRecId($event)"
                      >
                        <option value="">Selecteer volmachtgever</option>
                        <option v-for="(signee, index) in signees" :key="index" :data-index="index" :initvalue="signee.ppwRecId" :value="signee.ppwRecId" >{{signee.name}}</option>
                      </v-select-group>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row saveAcc" id="step3">
                <v-button :disabled="accountabilitySigned || !selectedSignee" tagelement="button" lg cta @click.native.once="gtmTrackSigning">Ondertekenen</v-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <generic-modal v-if="orderIsSaved">
      <template #body>
        <v-paragraph v-if="isNewAccountability">Order voor {{patientGegevens.Voorletters}} {{patientGegevens.Tussenvoegsel}} {{patientGegevens.Achternaam}} is verzonden. Ga terug naar:</v-paragraph>
        <v-paragraph v-if="!isNewAccountability">Uw wijziging/verlenging is doorgevoerd voor {{patientGegevens.Voorletters}} {{patientGegevens.Tussenvoegsel}} {{patientGegevens.Achternaam}}</v-paragraph>
      </template>
      <template #footer>
        <router-link to="/" class="btn btn--hollow btn--transparent btn--md" >Mijn Dashboard</router-link>
        <router-link to="/patientdashboard" class="btn btn--primary btn--md">Naar patiëntendashboard</router-link>
      </template>
    </generic-modal>
  </div>
</template>
<script>
  import $ from 'jquery'
  import store from '@/store'
  import router from '@/router'
  import { mapGetters, mapActions } from 'vuex'
  import VProduct from './selectProduct/Product'
  import VEmptyMessage from './selectProduct/EmptyMessage'
  import { Validator } from 'vee-validate'
  import GenericModal from '@/components/shared/GenericModal'
  import VWarningMessage from '@/components/shared/WarningMessage'
  import VCheckboxGroup from '@/components/shared/form/CheckboxGroup'
  import VButton from '@/components/shared/Button.vue'
  import VHeader from '@/components/sections/patient/accountability/PatientAccountabilityHeader'
  import VParagraph from '@/components/shared/Paragraph'
  import VTextareaGroup from '@/components/shared/form/TextareaGroup'
  import VInputDatePicker from '@/components/shared/form/simple/InputDatePicker'
  import { localDateToJson, stringToLocalDate } from '@/services/date.service'
  import 'intro.js/minified/introjs.min.css'
  import introJs from 'intro.js'
    import {
    getAccountabilityRootStatus,
    currentUserIdentity$,
    getSignees
  } from '@/services';
  import { router$ } from '@/router/router$';
  import { map, filter, switchMap, publishReplay, refCount } from 'rxjs/operators';

  export default {
    name: 'PatientAccountabilityOverview',
    components: {
      VTextareaGroup,
      VParagraph,
      VButton,
      VEmptyMessage,
      VCheckboxGroup,
      VHeader,
      VProduct,
      VInputDatePicker,
      VWarningMessage,
      GenericModal
    },
    subscriptions () {
      var accountabilityId$ = router$.pipe(
          map(route => route && route.params.id / 1),
          filter(accountabilityId => !!accountabilityId)
        );
      const accountability$ = accountabilityId$.pipe(
        switchMap(accountabilityId => this.loadAccountability(accountabilityId)),
        publishReplay(1),
        refCount()
      );

      const treatmentAreaId$ = accountability$.pipe(
        map(accountability => accountability.TreatmentAreaId)
      );

      const signees$ = treatmentAreaId$.pipe(
        switchMap(treatmentAreaId => getSignees(treatmentAreaId)),
        publishReplay(1),
        refCount()
      )

      return {
        accountabilityId: accountabilityId$,
        productSelectionAccountabilityId: accountabilityId$.pipe(
          switchMap(accountabilityId => getAccountabilityRootStatus(accountabilityId)),
          map(accountabilityRootStatus => accountabilityRootStatus.productSelection ? accountabilityRootStatus.productSelection.accountabilityId : null)
        ),
        user: currentUserIdentity$,
        treatmentAreaId: treatmentAreaId$,
        signees: signees$
      };
    },
    data () {
      return {
        validator: new Validator(),
        formData: {
          VTPlusVoorwaarden1: null,
          VTPlusVoorwaarden2: null,
          VTPlusVoorwaarden3: null,
          isdirectdelivery: 'true'
        },
        dateBetweenRange: 2,
        isVTPlus: null,
        showDirectDeliveryMsg: true,
        formErrors: {},
        holidayDates: [],
        differentAddress: false,
        hospitalAddress: false,
        thuiszorgFields: false,
        thuiszorgQuestion: false,
        orderIsSaved: false,
        formConfig: null,
        accountabilitySigned: false,
        addressLookup: {
          City: null,
          Street: null
        },
        oStreet: '',
        oCity: '',
        extendLicenseOptions: [
          {value: 1, label: '1 maand'},
          {value: 2, label: '2 maanden'},
          {value: 3, label: '3 maanden'},
          {value: 6, label: '6 maanden'},
          {value: 12, label: '12 maanden'}
        ],
        extendLicensesMonth: 1,
        deliveryInstructionErrorMsg: 0,
        formSubmitted: false,
        showInstructionOptions: false,
        extendLicenseFromEndDate: false,
        repeatOrder: false,
        intro: introJs(),
        selectedSigneePpwRecId: "",
        isCheckThuiszorg: false
      }
    },
    watch: {
      addressLookup () {
        if (this.addressLookup.Street && this.addressLookup.City) {
          this.formData[this.formConfig.newAddressStraatnaam.ref] = this.addressLookup.Street
          this.oStreet = this.addressLookup.Street
          this.oCity = this.addressLookup.City
          this.formData[this.formConfig.newAddressWoonplaats.ref] = this.addressLookup.City
          this.formConfig.newAddressStraatnaam.overwriteValue = this.addressLookup.Street
          this.formConfig.newAddressWoonplaats.overwriteValue = this.addressLookup.City
          this.validateField(this.formConfig.newAddressStraatnaam.ref, this.formData[this.formConfig.newAddressStraatnaam.ref])
          this.validateField(this.formConfig.newAddressWoonplaats.ref, this.formData[this.formConfig.newAddressWoonplaats.ref])
        } else {
          this.formConfig.newAddressStraatnaam.overwriteValue = null
          this.formConfig.newAddressWoonplaats.overwriteValue = null
          this.oStreet = null
          this.oCity = null
        }
      },
      // Set 'repeatOrder' status to false on the change of status 'showDirectDeliveryMsg'
      showDirectDeliveryMsg (value) {
        this.repeatOrder = false
      }
    },
    computed: {
      computedNextDayStatus () {
        let currentDate = new Date()
        return currentDate.getHours() > 16 ? true : false
      },
      ...mapGetters({
        patientGegevens: 'patient/getPatientGegevens',
        stamDataLanden: 'navigation/getStamDataLanden',
        productsSelectedNoDailyDosage: 'selectProduct/getProductsSelectedNoDailyDosage',
        productsSelectedDailyDosage: 'selectProduct/getProductsSelectedDailyDosage',
        questions: 'accountability/getQuestions',
        isSingleAccountability: 'accountability/getIsSingleAccountability',
        hasAccessories: 'accountability/getIsAccessoriesSelected',
        isNewAccountability: 'accountability/getIsNewAccountability',
        title: 'accountability/getTitleAccountability',
        texts: 'accountability/getTexts',
        userMarketingPermission: 'navigation/getUserMarketingPermission',
        showExtendLicensesBlock: 'accountability/getShowExtendLicensesBlock',
        ExtendLicenseMsg: 'accountability/getExtendLicenseMsg',
        isStartDate: 'accountability/getIsStartDate',
        customStartDate: 'accountability/getStartDateForTwoColumnAccountability',
        deliveryInstructionLabels: 'accountability/getDeliveryInstruction',
        deliveryDetails: 'accountability/getDeliveryDetails'
       
      }), 
      canSign () {
        return this.signees && this.signees.length > 0;
      },
      hasMultipleSignees () {
        return this.signees && this.signees.length > 1;
      },
      hasSingleSignee () {
        return this.signees && this.signees.length === 1;
      },
      selectedSignee () {
        if (this.hasSingleSignee) {
          return this.signees[0];
        }
        else if (this.hasMultipleSignees) {
          return this.signees.find((v) => v.ppwRecId == this.selectedSigneePpwRecId);
        }

        return null;
      },
      isSignable () {
        return this.isLastAnswer && this.canSign && this.selectedSignee;
      },
      // E40-7258 currently removing VTPlus as per requirement may be in future will revert back
      VTPlusVisibilityStatus () {
        return this.userMarketingPermission && this.patientGegevens.HasAgreedToShareData && !this.hasAccessories
        && this.patientGegevens.CareProgramInfo && this.patientGegevens.CareProgramInfo.VTPlus
      }
    },
    async created () {
    },
    methods: {
      ...mapActions('patient', ['fetchAllPatientFormData', 'fetchAllPatientFormData']),
      ...mapActions('accountability', ['submitAndSignAccountabilityForm']),
      updateValidation(date) {
      const d = stringToLocalDate(date)
      const dJson = localDateToJson(d)
        this.formData['Datum Aflevermoment'] = dJson
      },
      async loadAccountability (accountabilityId) {
        await store.dispatch('accountability/fetchTexts')
        await store.dispatch('patient/getCurrentPatient')
        this.holidayDates = await store.dispatch('accountability/fetchCalendarDates')
        const response = await store.dispatch('accountability/getQuestions', accountabilityId);

        this.validator.extend('VTPlusAgree', {
          getMessage: field => `U moet akkoord gaan met de voorwaarden van Voedingstherapie Plus.`,
          validate: value => {
            return value
          }
        })

        this.formConfig = {
          newAddressPostcode: {
            ref: 'Postcode',
            label: 'Postcode',
            rule: {
              required: true,
              regex: [/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i]
            },
            attached: false
          },
          newAddressHuisnummer: {
            ref: 'Huisnummer',
            label: 'Huisnummer',
            rule: {
              required: true
            },
            attached: false
          },
          newAddressToevoeging: {
            ref: 'Toevoeging',
            label: 'Toevoeging',
            rule: {
              required: false
            },
            attached: false
          },
          newAddressStraatnaam: {
            ref: 'Straatnaam',
            label: 'Straatnaam',
            rule: {
              required: true
            },
            attached: false
          },
          newAddressWoonplaats: {
            ref: 'Woonplaats',
            label: 'Woonplaats',
            rule: {
              required: true
            },
            attached: false
          },
          newAddressLand: {
            ref: 'Land',
            label: 'Land',
            rule: {},
            attached: false
          },
          hospitalDelivery: {
            ref: 'hospital',
            label: 'Ziekenhuis',
            rule: {},
            attached: false
          },
          hospitalNameDepartment: {
            ref: 'Naam / Afdeling ziekenhuis',
            label: 'Naam / Afdeling',
            rule: {
              required: true
            },
            attached: false
          },
          hospitalTelephone: {
            ref: 'Afdeling telefoonnummer',
            label: 'Afdeling telefoonnummer',
            rule: {
              required: true,
              regex: [/^(?=^.{11}$)0\d+[- ]\d+$|^(?=^.{10}$)0\d+$/]
            },
            attached: false
          },
          deliveryTime: {
            ref: 'Dagdeel Aflevermoment',
            label: 'Dagdeel',
            rule: {
              required: false
            },
            attached: this.hasAccessories
          },
          instruction: {
            ref: 'instructie',
            label: this.deliveryInstructionLabels.Header,
            rule: {},
            attached: false
          },
          homecare: {
            ref: 'Homecare',
            label: 'Is thuiszorg ingeschakeld?',
            rule: {},
            attached: false
          },
          nameThuiszorg: {
            ref: 'Naam thuiszorgorganisatie',
            label: 'Naam thuiszorgorganisatie',
            rule: {
              required: true
            },
            attached: this.thuiszorgFields

          },
          telephoneThuiszorg: {
            ref: 'Telefoon thuiszorgorganisatie',
            label: 'Telefoon thuiszorgorganisatie',
            rule: {
              required: true
            },
            attached: false
          },
          comment: {
            ref: 'comment',
            label: 'Vul hier een eventuele opmerking in, bijv. voor- afkeur voor smaken',
            rule: {},
            attached: false
          },
          IsVTPlus: {
            ref: 'IsVTPlus',
            model: false,
            alias: '',
            rule: {},
            attached: false
          },
          isdirectdelivery: {
            ref: 'isdirectdelivery',
            model: this.patientGegevens.isdirectdelivery,
            alias: '',
            rule: {},
            attached: false
          },
          instructionType: {
            ref: 'instructionType',
            alias: '',
            rule: {},
            attached: false
          },
          extendLicense: {
            ref: 'extendLicense',
            model: this.extendLicensesMonth,
            label: '',
            rule: {},
            attached: false
          }
        }
        if (this.patientGegevens.CustomerMarketingPermission) {
          this.formConfig.IsVTPlus.model = this.patientGegevens.CustomerMarketingPermission.VTPlus
        }
        if (this.deliveryDetails && Object.keys(this.deliveryDetails).length > 0 && this.deliveryDetails.HomeCare === 1) {
          this.isCheckThuiszorg = true
          this.thuiszorgQuestion = true
          this.formData[this.formConfig.homecare.ref] = this.deliveryDetails.HomeCare
          this.thuiszorgFields = true
          this.formData[this.formConfig.nameThuiszorg.ref] = this.deliveryDetails.HomeCareOrganizationName
          this.formData[this.formConfig.telephoneThuiszorg.ref] = this.deliveryDetails.PhoneOfHomeCareOrganization
          this.validator.attach(this.formConfig.nameThuiszorg.ref, this.formConfig.nameThuiszorg.rule)
          this.validator.attach(this.formConfig.telephoneThuiszorg.ref, this.formConfig.telephoneThuiszorg.rule)
        } else if (this.deliveryDetails && Object.keys(this.deliveryDetails).length > 0 && this.deliveryDetails.HomeCare !== 0) {
          this.isCheckThuiszorg = true
          this.thuiszorgQuestion = true
          this.formData[this.formConfig.homecare.ref] = this.deliveryDetails.HomeCare
          this.thuiszorgFields = false
          this.formData[this.formConfig.nameThuiszorg.ref] = ''
          this.formData[this.formConfig.telephoneThuiszorg.ref] = ''
          this.validator.detach(this.formConfig.nameThuiszorg.ref)
          this.validator.detach(this.formConfig.telephoneThuiszorg.ref)
        }
        // check if call for Landen is necessary
        if (!this.stamDataLanden.Landen) {
          await store.dispatch('navigation/fetchStamDataLanden')
        }

        if (!this.isSingleAccountability && this.productSelectionAccountabilityId) {
          await store.dispatch('selectProduct/fetchProductsSelected', this.productSelectionAccountabilityId)
        }

        // set original vtplus state, if true then dont show vtplus
        this.isVTPlus = this.patientGegevens.IsVTPlus

        this.formErrors = {
          [this.formConfig.newAddressPostcode.ref]: undefined,
          [this.formConfig.newAddressHuisnummer.ref]: undefined,
          [this.formConfig.newAddressToevoeging.ref]: undefined,
          [this.formConfig.newAddressStraatnaam.ref]: undefined,
          [this.formConfig.newAddressWoonplaats.ref]: undefined,
          [this.formConfig.newAddressLand.ref]: undefined,
          [this.formConfig.hospitalNameDepartment.ref]: undefined,
          [this.formConfig.hospitalTelephone.ref]: undefined,
          [this.formConfig.deliveryTime.ref]: undefined,
          [this.formConfig.nameThuiszorg.ref]: undefined,
          [this.formConfig.telephoneThuiszorg.ref]: undefined,
          [this.formConfig.comment.ref]: undefined,
          [this.formConfig.IsVTPlus.ref]: undefined,
          [this.formConfig.extendLicense.ref]: undefined
        }
        this.formData.address = this.formData.address = this.patientGegevens.WoonAdres

        this.attachFieldsToValidator()

        if (this.showExtendLicensesBlock) {
          $('html, body').animate({scrollTop: $(document).height()}, 'slow')
        }
        if (store.state.navigation.demo && store.state.navigation.demoActivated && store.state.navigation.demoFlow.createLicenseTwoColumn) {
          setTimeout(() => {
            const self = this
            this.intro.setOptions({
              steps: [
                {element: '#step1', intro: 'De laatste stap om je aanvraag af te ronden. Op deze pagina kan je alles nogmaals controleren wat we zojuist gedaan hebben. Ziet het er goed uit? Klik dan op volgende.', position: 'right'},
                {element: '#step2', intro: 'Wil je dat we de geselecteerde producten bij de patient leveren? Wanneer niet nodig selecteer hier dan Nee.', position: 'right'},
                {element: '#step3', intro: 'Yes, we zijn er. Druk op Ondertekenen en vanaf dit punt regelt Mediq alles zodat jij weer door kan.', position: 'right'}
              ],
              exitOnEsc: false,
              exitOnOverlayClick: false,
              skipLabel: 'Overslaan',
              nextLabel: 'Volgende >',
              prevLabel: '< Terug',
              doneLabel: 'Okey, begrepen'
            })
            this.intro.start().oncomplete(function () {
              self.exitDemo()
            })
            window.scrollTo(0, 0)
          }, 1500)
        }
        return response
      },
      checkRadioAddress (e) {
        this.validator.detach(this.formConfig.newAddressPostcode.ref)
        this.validator.detach(this.formConfig.newAddressHuisnummer.ref)
        this.validator.detach(this.formConfig.newAddressToevoeging.ref)
        this.validator.detach(this.formConfig.newAddressStraatnaam.ref)
        this.validator.detach(this.formConfig.newAddressWoonplaats.ref)
        this.validator.detach(this.formConfig.newAddressLand.ref)
        this.validator.detach(this.formConfig.hospitalNameDepartment.ref)
        this.validator.detach(this.formConfig.hospitalTelephone.ref)
        let checkedAddress = document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id
        if (checkedAddress === 'woonadres') {
          this.formData.address = this.patientGegevens.WoonAdres
          this.differentAddress = false
          this.hospitalAddress = false
        } else if (checkedAddress === 'afwijkendwoonadres') {
          this.formData.address = this.patientGegevens.AfwijkendeAdres
          this.differentAddress = false
          this.hospitalAddress = false
        } else if (checkedAddress === 'differentaddress') {
          this.formData.address = {
            [this.formConfig.newAddressPostcode.ref]: this.formData[[this.formConfig.newAddressPostcode.ref]],
            [this.formConfig.newAddressHuisnummer.ref]: this.formData[[this.formConfig.newAddressHuisnummer.ref]],
            [this.formConfig.newAddressToevoeging.ref]: this.formData[[this.formConfig.newAddressToevoeging.ref]],
            [this.formConfig.newAddressStraatnaam.ref]: this.formData[[this.formConfig.newAddressStraatnaam.ref]],
            [this.formConfig.newAddressWoonplaats.ref]: this.formData[[this.formConfig.newAddressWoonplaats.ref]],
            [this.formConfig.newAddressLand.ref]: this.formData[[this.formConfig.newAddressLand.ref]]
          }
          this.differentAddress = true
          this.hospitalAddress = false
          this.validator.attach(this.formConfig.newAddressPostcode.ref, this.formConfig.newAddressPostcode.rule)
          this.validator.attach(this.formConfig.newAddressHuisnummer.ref, this.formConfig.newAddressHuisnummer.rule)
          this.validator.attach(this.formConfig.newAddressToevoeging.ref, this.formConfig.newAddressToevoeging.rule)
          this.validator.attach(this.formConfig.newAddressStraatnaam.ref, this.formConfig.newAddressStraatnaam.rule)
          this.validator.attach(this.formConfig.newAddressWoonplaats.ref, this.formConfig.newAddressWoonplaats.rule)
          this.validator.attach(this.formConfig.newAddressLand.ref, this.formConfig.newAddressLand.rule)
          this.validator.detach(this.formConfig.hospitalNameDepartment.ref)
          this.validator.detach(this.formConfig.hospitalTelephone.ref)
        } else if (checkedAddress === 'hospital') {
          this.formData.address = {}
          this.differentAddress = false
          this.hospitalAddress = true
          this.validator.attach(this.formConfig.hospitalNameDepartment.ref, this.formConfig.hospitalNameDepartment.rule)
          this.validator.attach(this.formConfig.hospitalTelephone.ref, this.formConfig.hospitalTelephone.rule)
        } else {
          this.differentAddress = false
          this.hospitalAddress = false
        }
      },
      showThuiszorgQuestion (e) {
        if (!e) {
          this.formData[this.formConfig.homecare.ref] = 0
        }
        this.thuiszorgQuestion = e
        this.isCheckThuiszorg = e
      },
      checkThuiszorg (e) {
        let fieldName = e.currentTarget.value
        if (fieldName === '1') {
          this.thuiszorgFields = true
          this.validator.attach(this.formConfig.nameThuiszorg.ref, this.formConfig.nameThuiszorg.rule)
          this.validator.attach(this.formConfig.telephoneThuiszorg.ref, this.formConfig.telephoneThuiszorg.rule)
        }
        else {
          this.thuiszorgFields = false
          this.validator.detach(this.formConfig.nameThuiszorg.ref)
          this.validator.detach(this.formConfig.telephoneThuiszorg.ref)
        }
      },
      attachFieldsToValidator () {
        for (let key in this.formConfig) {
          if (this.formConfig[key].attached) {
            this.validator.attach(
              this.formConfig[key].ref,
              this.formConfig[key].rule,
              { alias: this.formConfig[key].label })
          }
        }
      },
      validateBeforeSubmit () {
        if (store.state.navigation.demo && store.state.navigation.demoActivated && store.state.navigation.demoFlow.createLicenseTwoColumn) {
          this.exitDemo()
        }
        this.formSubmitted = true
        this.validateAllFields()
        this.setErrors()
      },
      validateAllFields () {
        const validateObj = {}
        for (let key in this.formConfig) {
          const config = this.formConfig[key]
          if (typeof config.ref !== 'undefined') {
            validateObj[config.ref] = this.formData[config.ref]
          }
        }
        this.validator.validateAll(validateObj).then(validated => {
          if (validated && !(this.formSubmitted && this.showInstructionOptions && this.deliveryInstructionErrorMsg === 0)) {
            this.accountabilitySigned = true
            this.formData.isvtplus = this.formConfig.IsVTPlus.model
            if (this.formData.address.Postcode === undefined || this.formData.address.Huisnummer === undefined ||
            this.formData.address.Straatnaam === undefined || this.formData.address.Woonplaats === undefined) {
              this.formData.address = {
                [this.formConfig.newAddressPostcode.ref]: this.formData.Postcode,
                [this.formConfig.newAddressHuisnummer.ref]: this.formData.Huisnummer,
                [this.formConfig.newAddressToevoeging.ref]: this.formData.Toevoeging,
                [this.formConfig.newAddressStraatnaam.ref]: this.formData.Straatnaam,
                [this.formConfig.newAddressWoonplaats.ref]: this.formData.Woonplaats,
                [this.formConfig.newAddressLand.ref]: this.formData.Land
              }
            }
            if (this.differentAddress) {
              let diffAddress = 'Afwijkend Afleveradres: ' + this.formData.address[[this.formConfig.newAddressPostcode.ref]] +
              ', ' + this.formData.address[[this.formConfig.newAddressHuisnummer.ref]]
              if (this.formData.address[[this.formConfig.newAddressToevoeging.ref]]) {
                diffAddress = diffAddress + ' ' + this.formData.address[[this.formConfig.newAddressToevoeging.ref]]
              }
              diffAddress = diffAddress + ', ' + this.formData.address[[this.formConfig.newAddressStraatnaam.ref]] +
              ', ' + this.formData.address[[this.formConfig.newAddressWoonplaats.ref]] +
              ', ' + this.formData.address[[this.formConfig.newAddressLand.ref]]
              if (this.formData[[this.formConfig.comment.ref]]) {
                this.formData[[this.formConfig.comment.ref]] = 'Remarks: ' + this.formData[[this.formConfig.comment.ref]] +
                ', ' + diffAddress
              } else {
                this.formData[[this.formConfig.comment.ref]] = diffAddress
              }
            }
            if (this.isStartDate && this.customStartDate !== null) {
              const startDate = stringToLocalDate(this.customStartDate)
              const startDateJson = localDateToJson(startDate)

              this.formData.startDate = startDateJson
            }
            if (this.showExtendLicensesBlock) {
              this.formData[[this.formConfig.extendLicense.ref]] = this.extendLicensesMonth
              this.formData.extendLicenseFromEndDate = this.extendLicenseFromEndDate
              if (!this.extendLicenseFromEndDate) {
                const startDateJson = localDateToJson(new Date())

                this.formData.startDate = startDateJson
              }
            }
            this.formData.signeePpwRecId = this.selectedSignee.ppwRecId
            this.formData.repeatOrder = this.repeatOrder
            this.formData.accountabilityId = this.accountabilityId;
            this.submitAndSignAccountabilityForm(this.formData).then(() => {
              this.$emit('success')
              this.orderIsSaved = true
              store.commit('accountability/setShowExtendLicensesBlock', false)
            })
          } else {
            console.log(this.validator.errors)
          }
        }).catch(() => {
        })
      },
      validateField (ref, model) {
        this.formSubmitted = false
        this.validator.validate(ref, model)
        this.setErrors()
      },
      setErrors () {
        // If the validator contains no errors
        if (this.validator.errors.items.length === 0) {
          for (let key in this.formConfig) {
            if (typeof this.formConfig[key].ref !== 'undefined') {
              this.formErrors[this.formConfig[key].ref] = undefined
            }
          }
        } else if (this.validator.errors.items.length > 0) {
          // If the validator contains errors
          const keysWithErrors = []
          const keysWithoutErrors = []

          // Loop through all the fields
          for (let key in this.formConfig) {
            let keyHasError = false
            let keyError = {}
            // Loop over all the errors
            this.validator.errors.items.forEach((error, index) => {
              // If the field has an error then assign that error to the field
              if (this.formConfig[key].ref === error.field) {
                keyHasError = true
                keyError = error
              }
              // If at the end of the loop then push it in the right array
              if (this.validator.errors.items.length - 1 === index) {
                if (keyHasError === true) {
                  keysWithErrors.push({
                    key: key,
                    error: keyError
                  })
                } else if (typeof this.formConfig[key].ref !== 'undefined') {
                  keysWithoutErrors.push(key)
                }
              }
            })
          }
          // Keys without errors are set to no error
          keysWithoutErrors.forEach((key) => {
            this.formErrors[this.formConfig[key].ref] = undefined
          })
          // Keys with errors are set to there error message
          keysWithErrors.forEach((obj) => {
            this.formErrors[this.formConfig[obj.key].ref] = obj.error.msg
          })
        }
      },
      gtmTrackSigning () {
        if (this.$gtm) {
          this.$gtm.trackEvent({
            event: 'ButtonClick',
            event_category: 'Dieetpreparaat aanvragen',
            event_action: 'Ondertekenen'
          })
        }
      },
      toggleCheckboxVTPlus (active) {
        if (active) {
          this.validator.attach(
            this.formConfig.VTPlusVoorwaarden1.ref,
            this.formConfig.VTPlusVoorwaarden1.rule,
            {alias: this.formConfig.VTPlusVoorwaarden1.alias})
          this.validator.attach(
            this.formConfig.VTPlusVoorwaarden2.ref,
            this.formConfig.VTPlusVoorwaarden2.rule,
            {alias: this.formConfig.VTPlusVoorwaarden2.alias})
          this.validator.attach(
            this.formConfig.VTPlusVoorwaarden3.ref,
            this.formConfig.VTPlusVoorwaarden3.rule,
            {alias: this.formConfig.VTPlusVoorwaarden3.alias})
        } else {
          this.validator.detach(this.formConfig.VTPlusVoorwaarden1.ref)
          this.validator.detach(this.formConfig.VTPlusVoorwaarden2.ref)
          this.validator.detach(this.formConfig.VTPlusVoorwaarden3.ref)
        }
      },
      autoFillAddress () {
        store.dispatch('patient/fetchAddressLookup', {
          postcode: this.formData[this.formConfig.newAddressPostcode.ref],
          huisnummer: this.formData[this.formConfig.newAddressHuisnummer.ref],
          land: this.formData[this.formConfig.newAddressLand.ref]
        }).then((response) => {
          this.addressLookup = response.data
          if (this.addressLookup.City === null) {
            this.formConfig.newAddressStraatnaam.disabled = false
            this.formConfig.newAddressWoonplaats.disabled = false
          } else {
            this.formConfig.newAddressStraatnaam.disabled = true
            this.formConfig.newAddressWoonplaats.disabled = true
          }
        }).catch(() => {
          this.addressLookup = { City: null, Street: null }
          this.formConfig.newAddressStraatnaam.disabled = false
          this.formConfig.newAddressWoonplaats.disabled = false
        })
      },
      checkSelectAnswer (e) {
        this.extendLicensesMonth = e.currentTarget.value
      },
      updateInstructionType (instructionOptions) {
        this.showInstructionOptions = instructionOptions
        if (!instructionOptions) {
          this.deliveryInstructionErrorMsg = 0
          this.formSubmitted = false
          this.formData[this.formConfig.instructionType.ref] = null
        }
      },
      exitDemo () {
        this.intro.exit()
        store.commit('navigation/setDemoFlowStatus', {key: 'createLicense', value: false})
        store.commit('navigation/setDemoFlowStatus', {key: 'createLicenseTwoColumn', value: false})
        store.commit('navigation/setDemoFlowStatus', {key: 'showLicense', value: true})
        router.push('/patientdashboard')
      },
      setSelectedSigneePpwRecId (event) {
        this.selectedSigneePpwRecId = event.currentTarget.value
      }
    },
    destroyed () {
      store.commit('accountability/setQuestions', [])
      store.commit('selectProduct/resetProductsAndFilters')
    }
  }
</script>

<style lang="scss" scoped>
  .prescriber__signature{
    img {
      border: solid 2px $grayish-med-light;
      vertical-align: text-top;
      max-width: 350px !important;
      height: auto;
      width: 100%;
    }
    /deep/
    .form-group {
      padding: 0px;
      label {
        font-weight: 900;
        color: $gray-dark;
        position: initial;
        transform: none !important;
        line-height: normal;
        background: transparent;
      }
      &__icon {
        margin: 25px 10px 0 0;
      }
      .form-group__details {
        &:after {
          content: none;
        }
        &:before {
          content: none;
        }
      }
    }
  }
  // Width of each table column
  $table-columns: (
    1: 40px,
    2: 30%,
    3: 30%,
    4: 15%,
    5: 15%,
    6: 50px
  ) !default;
  table {
    table-layout: auto !important;
    width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    text-align: left;
    // Generate classes for each column and assign width
    @each $table-column-key, $table-column-value in $table-columns {
      .table-col-#{$table-column-key} {
        width: $table-column-value
      }
    }
    > tbody {
      > tr:first-child {
        > td, > th {
          vertical-align: baseline;
          text-align: left;
          padding: 16px 10px;
        }
      }
      > tr:last-child td {
        padding: 10px 10px 16px;
      }
    }

    .hidden {
      display: none;
    }
  }
  .extendLicenseFromEndDate {
    margin-bottom: 20px;
  }
  .saveAcc {
    margin: 24px 0 24px 0;
  }
  .extHeader {
    min-width: 200px;
  }
  .full-width-header{
    width:100%;
  }
  .inline {
    display: inline-flex;
  }
  .main__view{
    padding:0;
    h3{
      margin-top:16px;
      margin-bottom: 16px;
    }
  }
  .products-selected {
    background: $white;
    border: 1px solid $gray-light;
    padding: 16px;
    &__list {
      position: relative;
      padding: 0;
      margin: 0;
      min-height: 100px;
      &.daily_dosage {
        .product__text__dosage {
          color: $gray-darkest;
          position: absolute;
          bottom: -15px;
          right: 0;
        }
      }
    }
  }
  .products-seperator {
    padding-top: 20px;
    padding-bottom: 10px;
    border-bottom: solid 2px $gray-dark;
  }
  .link {
    text-decoration: underline;
    color: $teal-darkest;
    text-align: end;
  }
  legend{
    font-weight: bold;
    color: $gray-dark;
  }
  .extrafields {
    margin:0 28px;
    color: $gray-dark;
  }
   .datepicker {
    margin-top: 18px;
  }
  .accountability-overview {
    background: $white;
    border: 1px solid $gray-light;
    color: $gray-dark;
    margin-bottom: 16px;
    td{
      padding:16px;
      &:nth-child(2){
        font-weight: bold;
        min-width: 200px;
      }
    }
  }
  .information-container {
    border: 1px solid $teal;
    background: $teal-lighter;
    padding: 16px;
    margin: 16px 0 0 ;
    h3 {
      margin:0;
      color: $gray-dark;
      font-weight: bold;
    }

  }
  .instruction-type {
    margin: 0px 0px 20px 34px !important;
    font-size: 14px;
    color: #333333;
    line-height: 1.5em;
  }
  .fade-enter-active, .fade-leave-active {
    max-height: 500px;
    transition:all 0.65s ease-in;
    opacity: 1;
  }
  .fade-enter, .fade-leave-to {
    max-height: 0;
    opacity: 0;
    transition: all 0.45s ease-out;
    overflow: hidden;
  }
  /deep/.checkbox-group .checkbox-group__label__inner{
    white-space: nowrap;
  }
  .vtplusvoorwaarden {
    color: $gray-dark;
    padding-bottom: 20px;
  }
  .extendLicenses {
    color: $gray-dark;
    padding-bottom: 20px;
  }
  /deep/
  .form-group {
    input {
      background: transparent;
    }
  }
  .rte {
    p {
      margin-bottom: 0.5rem;
    }
  }
  .delivery_rdb_question {
    align-items: flex-start;
  }
  .delivery_rdb_answer {
    align-items: start;
    margin-left: 30px;
  }
   .delivery_txt_answer {
    margin-left: 35px;
  }
</style>
